import styled from "@emotion/styled";

export const Container = styled.div`
  position: relative;
`;

export const StyledButton = styled.button`
  z-index: 1;

  padding: 0;

  border: none;

  background-color: transparent;

  cursor: pointer;
`;

export const CountMessage = styled.span`
  position: absolute;
  inset-block-start: -10px;
  inset-inline-start: 16px;
  z-index: 0;

  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;

  min-inline-size: 16px;
  padding: 2px;

  color: #ffffff;
  font-size: 12px;
  line-height: 14px;

  border-radius: 2px;

  background-color: #eb4254;
`;

export const NoPostMessage = styled.div`
  position: absolute;
  inset-block-start: -29px;
  inset-inline-start: -2px;

  color: #001246;
  font-size: 18px;
  line-height: 21px;
`;
